/**
 * Shared asset UI helpers — badges, labels, colors.
 */

import { Badge } from "../ui/index.jsx";

const STATUS_CONFIG = {
  ACTIVE: { label: "Active", variant: "success" },
  IDLE: { label: "Idle", variant: "default" },
  DAMAGED: { label: "Damaged", variant: "danger" },
  UNDER_REPAIR: { label: "Under Repair", variant: "warning" },
  RETIRED: { label: "Retired", variant: "inactive" },
  LOST: { label: "Lost", variant: "danger" },
};

const EVENT_LABELS = {
  CREATED: "Created",
  ASSIGNED: "Assigned",
  RETURNED: "Returned",
  REASSIGNED: "Reassigned",
  RELOCATED: "Relocated",
  STATUS_CHANGED: "Status Changed",
  CHECKED: "Checked",
  TRANSFERRED: "Transferred",
  RETIRED: "Retired",
  RESTORED: "Restored",
};

export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] ?? { label: status, variant: "default" };
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}

export function getStatusLabel(status) {
  return STATUS_CONFIG[status]?.label ?? status;
}

export function getEventLabel(eventType) {
  return EVENT_LABELS[eventType] ?? eventType;
}

export const ASSET_STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(
  ([value, { label }]) => ({ value, label }),
);

export const PAYMENT_SOURCE_OPTIONS = [
  { value: "CASH", label: "Cash" },
  { value: "CREDIT_CARD", label: "Credit Card" },
  { value: "INSTALLMENT", label: "Installment" },
  { value: "HIBAH", label: "Hibah / Grant" },
  { value: "OTHER", label: "Other" },
];
